import React, {useState} from "react";
import type { NavProps } from "./types";

import { Link } from "gatsby";
import Logo from "../../images/Logo.svg";
import HMenu from "../../images/Hamburger-Menu.svg"

import "./style.scss";


function Navbar({ sections, langs }: NavProps) {

  const [showMobile, setShowMobile] = useState(false)

  return (
    <nav id="Navbar" className="Navbar">
      <div className="Navbar__menu">
        <img 
          onClick={() => { setShowMobile(!showMobile) }}
          className="Navbar__menu__mobile" src={HMenu} alt="menu" />
        <ul className={`Navbar__menu__desktop ${ showMobile ? "show" : "" }`}>
          <li className="Navbar__menu__desktop__close" onClick={() => { setShowMobile(!showMobile) }} > x </li>

          {sections.map((section) => {
            return (
              <li key={section.path}>
                <Link to={`${section.path}`}> {section.display} </Link>
              </li>
            );
          })}
        </ul>
      </div>

      <div className="logo">
        <img src={Logo} alt="Logo" />
      </div>

      <div className="Navbar__langs">
        {langs.map((lang) => (
          <div key={`${lang.path}`} className="lang">
            <Link to={`/${lang.path}`}>{lang.display}</Link>
          </div>
        ))}
      </div>
    </nav>
  );
}

export default Navbar;
